import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { lightSteel, steel } from '../../styles/colors';
import { IconXCircle } from '../Icons';
import { CloseButton, IconSearchStyled, SearchInputContainer, RoundedSearchInput } from './FormInputStyledComponents';
var SearchInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var autoFocus = _ref.autoFocus,
      className = _ref.className,
      disabled = _ref.disabled,
      loading = _ref.loading,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      placeholder = _ref.placeholder,
      showClearButton = _ref.showClearButton,
      small = _ref.small,
      style = _ref.style,
      truncatePlaceholder = _ref.truncatePlaceholder,
      value = _ref.value,
      htmlAttributes = _ref.htmlAttributes;
  return /*#__PURE__*/React.createElement(SearchInputContainer, {
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(RoundedSearchInput, _extends({
    autoFocus: autoFocus,
    disabled: disabled,
    onChange: onChange,
    placeholder: placeholder,
    small: small,
    truncatePlaceholder: truncatePlaceholder,
    type: "text",
    value: value
  }, htmlAttributes, {
    ref: ref
  })), /*#__PURE__*/React.createElement(IconSearchStyled, {
    color: steel,
    "data-testid": "search-input-icon",
    loading: loading,
    size: small ? 'small' : 'medium',
    small: small ? 1 : 0
  }), showClearButton && /*#__PURE__*/React.createElement(CloseButton, {
    "data-testid": "search-input-close",
    onClick: onClear,
    small: small,
    type: "button",
    "aria-label": "Clear search input"
  }, /*#__PURE__*/React.createElement(IconXCircle, {
    color: lightSteel,
    size: small ? 'small' : 'medium'
  })));
});
SearchInput.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  showClearButton: PropTypes.bool,
  small: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  truncatePlaceholder: PropTypes.bool,
  value: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  htmlAttributes: PropTypes.object
};
SearchInput.defaultProps = {
  autoFocus: false,
  className: '',
  disabled: false,
  loading: false,
  onChange: function onChange() {},
  onClear: function onClear() {},
  placeholder: 'Search',
  showClearButton: false,
  small: false,
  style: {},
  truncatePlaceholder: false,
  value: undefined,
  htmlAttributes: {}
};
export default SearchInput;